



















import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import {
  DrivewealthWizardStep,
} from "@/shared/types";
import { formatCurrency } from "@/shared/currency";
import * as RouteNames from "@/employee/route-names";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import PreenrollmentCopyParagraphs from "@/employee/components/investments/drivewealth/PreenrollmentCopyParagraphs.vue";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";

@Component({
  components: {
    GenericLoadingSpinner,
    PreenrollmentCopyParagraphs,
  }
})
export default class PreenrollmentWidget extends Vue {
  @Prop() hsaInvestmentThreshold: number;
  DrivewealthWizardStep = DrivewealthWizardStep;
  formatCurrency = formatCurrency;
  RouteNames = RouteNames;

  portalCustomizationStore = usePortalCustomizationStore();

  get partnerName () {
    return this.portalCustomizationStore.supportInfo.displayName;
  }

  get preenrollmentUrl () {
    return { name: RouteNames.DrivewealthPreenrollment };
  }
}

